import React from "react";
import { useTranslation } from "react-i18next";

import { dateFormat, TimestampToDateMoment } from "../../../utils/timestampToDate";
import { StyledFilterList, StyledFilterListItem } from "./styledFiter";

const SERVICE_KEYS = ["page", "itemsPerPage", "currentTab"];

const TIMESTAMP_KEYS = [
  "createdAt",
  "createDate",
  "updatedAt",
  "datetime",
  "startDate",
  "dateFrom",
  "dateTo",
  "user.createDate"
];

// CashFlowBalancesHistoryFilter пише ці дати в мілісекундах, решта — у секундах
const MILLISECOND_KEYS = ["createAt"];

const BOOLEAN_KEYS = ["active", "enablePayment", "enablePayout"];

const LABEL_KEYS = {
  "action": "action",
  "active": "active",
  "amount[gt]": "amountFrom",
  "amount[gte]": "amountFrom",
  "amount[lte]": "amountTo",
  "asset": "currency",
  "bank": "bank",
  "baseFee.currency.asset": "currency",
  "baseFee.paymentSystem.name": "paymentSystem",
  "baseFee.service.name": "service",
  "baseFee.type": "feeType",
  "bin": "bin",
  "chatId": "chatId",
  "client": "client",
  "collection": "service",
  "connection.project.name": "project",
  "connection.project.user.email": "email",
  "connection.project.user.nickname": "nickname",
  "connection.service.name": "service",
  "constant[gte]": "constantFrom",
  "constant[lte]": "constantTo",
  "country": "country",
  "countryCode": "country",
  "createAt[gte]": "dateFrom",
  "createAt[lte]": "dateTo",
  "createDate[gte]": "dateFrom",
  "createDate[lte]": "dateTo",
  "createdAt[gte]": "dateFrom",
  "createdAt[lte]": "dateTo",
  "currency": "currency",
  "currency.asset": "currency",
  "dateFrom": "dateFrom",
  "dateTo": "dateTo",
  "datetime[gte]": "dateFrom",
  "datetime[lte]": "dateTo",
  "email": "email",
  "enablePayment": "enablePayment",
  "enablePayout": "enablePayout",
  "exchange.id": "exchangeId",
  "exchangeId": "exchangeId",
  "exchangePair.inCurrency.asset": "inCurrency",
  "exchangePair.inService.name": "inService",
  "exchangePair.outCurrency.asset": "outCurrency",
  "exchangePair.outService.name": "outService",
  "exclusionValues": "exclusionValues",
  "firstname": "firstname",
  "hash": "hash",
  "id": "id",
  "inAmount[gte]": "inAmountFrom",
  "inAmount[lte]": "inAmountTo",
  "inConnection.project.name": "inProject",
  "inConnection.project.user.email": "email",
  "inConnection.service.name": "inService",
  "inCurrency.asset": "inCurrency",
  "inPaymentSystem.subName": "inPaymentSystem",
  "inService.name": "inService",
  "invoiceId": "invoiceId",
  "ip": "ip",
  "lastname": "lastname",
  "level_name": "levelName",
  "limit": "limit",
  "managerId": "managerId",
  "masterBalance.currency.asset": "currency",
  "masterBalance.service.name": "service",
  "max[gte]": "maxFrom",
  "max[lte]": "maxTo",
  "message": "message",
  "min[gte]": "minFrom",
  "min[lte]": "minTo",
  "minAmount[gte]": "minAmountFrom",
  "minAmount[lte]": "minAmountTo",
  "name": "name",
  "nickname": "nickname",
  "note": "note",
  "operationId": "operationId",
  "outAmount[gte]": "outAmountFrom",
  "outAmount[lte]": "outAmountTo",
  "outConnection.service.name": "outService",
  "outCurrency.asset": "outCurrency",
  "outPaymentSystem.subName": "outPaymentSystem",
  "outService.name": "outService",
  "pair.exchangePair.inCurrency.asset": "inCurrency",
  "pair.exchangePair.inService.name": "inService",
  "pair.exchangePair.outCurrency.asset": "outCurrency",
  "pair.exchangePair.outService.name": "outService",
  "pair.user.email": "email",
  "pair.user.nickname": "nickname",
  "paymentSystem": "paymentSystem",
  "paymentSystem.name": "paymentSystem",
  "paymentType": "paymentType",
  "percent[gte]": "percentFrom",
  "percent[lte]": "percentTo",
  "processedAmount[gte]": "amountFrom",
  "processedAmount[lte]": "amountTo",
  "processingId": "processingId",
  "projectId": "project",
  "rateBase.currency.asset": "currency",
  "rateBase.service.name": "service",
  "receiver.email": "receiverEmail",
  "receiver.nickname": "receiverNickname",
  "referenceId": "referenceId",
  "relatedReferenceId": "relatedReferenceId",
  "resourceType": "resourceType",
  "role": "role",
  "sender.email": "senderEmail",
  "sender.nickname": "senderNickname",
  "service": "service",
  "service.name": "service",
  "serviceName": "service",
  "startDate[gte]": "startDateFrom",
  "startDate[lte]": "startDateTo",
  "status": "status",
  "status.value": "status",
  "tag": "tag",
  "totalAmount[gte]": "totalAmountFrom",
  "totalAmount[lte]": "totalAmountTo",
  "transactionId": "transactionId",
  "transactionType": "transactionType",
  "type": "type",
  "updatedAt[gte]": "updatedFrom",
  "updatedAt[lte]": "updatedTo",
  "user": "user",
  "user.createDate[gte]": "userCreatedFrom",
  "user.createDate[lte]": "userCreatedTo",
  "user.email": "email",
  "user.firstname": "firstname",
  "user.id": "userId",
  "user.lastname": "lastname",
  "user.nickname": "nickname",
  "value": "value",
  "wallet": "wallet"
};

const FilterAppliedList = ({ filterData, setFilterData, serviceKeys = [] }) => {
  const { t } = useTranslation("otherInterface");

  const keptKeys = [...SERVICE_KEYS, ...serviceKeys];

  const appliedFilters = Object.entries(filterData).filter(([key, value]) => (
    value !== null && value !== undefined && value !== "" && !keptKeys.includes(key)
  ));

  if (appliedFilters.length === 0) {
    return null;
  }

  const handleRemoveFilter = (key) => {
    setFilterData(prev => ({
      ...prev,
      [key]: null,
      page: 1
    }));
  };

  const handleClearFilter = () => {
    setFilterData(prev => {
      const clearedData = { ...prev, page: 1 };

      appliedFilters.forEach(([key]) => {
        clearedData[key] = null;
      });

      return clearedData;
    });
  };

  return (
    <StyledFilterList>
      <StyledFilterListItem as="button" type="button" clearAll onClick={handleClearFilter}>
        {t("filterAppliedList.clearAll")}
      </StyledFilterListItem>
      {appliedFilters.map(([key, value]) => {
        const label = LABEL_KEYS[key] ? t(`filterAppliedList.labels.${LABEL_KEYS[key]}`) : key;
        const isMillisecond = MILLISECOND_KEYS.some(millisecondKey => key.startsWith(millisecondKey));
        const isTimestamp = isMillisecond || TIMESTAMP_KEYS.some(timestampKey => key.startsWith(timestampKey));

        if (BOOLEAN_KEYS.includes(key)) {
          value = t(`filterAppliedList.options.${String(value) === "true" ? "active" : "inactive"}`);
        }

        return (
          <StyledFilterListItem
            key={key}
            title={isTimestamp ? label : `${label}: ${value}`}
          >
            <div className="key">{label}</div>
            :
            <div className="value">
              {isTimestamp ? TimestampToDateMoment(isMillisecond ? value / 1000 : value, dateFormat) : value}
            </div>
            <div
              className="remove icon-light-cancel"
              onClick={() => handleRemoveFilter(key)}
            />
          </StyledFilterListItem>
        );
      })}
    </StyledFilterList>
  );
};

export default FilterAppliedList;